import axios from 'axios'
import apiList from './apiList'
import _ from 'lodash'
import store from '@/store'
import router from '@/router'
import Vue from 'vue'
    let baseURL = "https://pro-api.minegou.cn/"  // 正式
    // let baseURL = "http://192.168.15.214:82/"    // 测试
    // let baseURL = "https://wuye.minegou.cn/"        // 测试

	Vue.prototype.$http = axios
    let api={}, call
    call = axios.create({
        baseURL:baseURL
    })

    //获取授权信息api-property.minegou.cn   http://192.168.15.214:82/  https://pro-api.minegou.cn/
    function getAuth (cb) {
      if (!store.getters.onSign){
        return errorMsg('尚未登录');
      }
      let auth = store.getters.auth;
      return cb(auth);
    }

    //移除授权信息(退出登录)
    function removeAuth () {
      store.commit('removeAuth');
      router.replace({name: 'SignIn'});
    }

    //报错
    function errorMsg (msg) {
      console.log(msg);
    }

    //连字符转驼峰命名
    function toCamelCase (str) {
        return str.replace(/\-(\w)/g, function(all, letter){
            return letter.toUpperCase();
        }); 
    }

    //调用服务端API
    function callAPI (uri, params, success, fail = null, options = {}){
        const config = {};
        if (options.formData) {
            config.transformRequest = (data) => {
                const form = new FormData();
                for (let k in data) {
                    form.append(k, data[k])
                }
            }
        }
        call.post(uri, params, config)
       
        .then(({data})=>{
            if(data.code == 0)
                return success(data.data)
            if (typeof fail === 'function') {
                fail(data, ()=>errorProcess(data))
            	if (fail.length <= 1) {
            		errorProcess(data);
            	}
            } else {
                errorProcess(data)
            }
        })
        .catch((error)=>{
            console.warn(error)
            return errorMsg('网络异常')
        })
    }

    //报错处理流程
    function errorProcess ({code, msg}) {
        if (code>2000 && code<3000) {
            removeAuth();
        }
        return errorMsg(msg);
    }

    //创建联系人方法
    function createLinkman (uri, options = {}) {
        return function (params, callback, fail) {
            if (!callback){
                callback = params;
                params = {};
            }
            if (!options.needAuth)
                return callAPI (uri, params, callback, fail, options);
            getAuth(({memberid, authkey})=>{
                if(uri == 'property/import'){
                    params.append('memberid', memberid);
                    params.append('authkey', authkey);
                } else {
                    params.memberid = memberid;
                    params.authkey = authkey;
                }
                return callAPI (uri, params, callback, fail, options);
            });
        }
    }
    //接口uri列表
    
    apiList.forEach(( { uri, options } )=>{
        let [uriClass, uriFunc] = uri.split("/");
        if (!api[uriClass]) api[uriClass] = {};
        uriFunc = toCamelCase(uriFunc);
        api[uriClass][uriFunc]
        = createLinkman(uri, options);
    })

    api.getBase = baseURL;

    export default api



// WEBPACK FOOTER //
// ./src/jssdk/api.js